import { apiGet } from 'shared/services/api/resource';
import { ARENA_KPIS } from 'modules/arena/dashboard/content';

export interface ArenaKpi {
  label: string;
  value: string;
}

export function fetchArenaKpis(): Promise<ArenaKpi[]> {
  return apiGet(ARENA_KPIS, '/arena/dashboard/kpis');
}
